import { HeimdallSession } from "@dvrt/graphql-widgets/heimdall";
import { AuthManagerBase } from "./managerBase";
import { ConferenceManager } from "./conferenceManager";
import { HeimdallManager } from "./heimdallManager";
import { ApolloClient } from "@apollo/client";
import { TStore } from "../types";

export const createManager = (apolloClient: ApolloClient<any>, store: TStore): AuthManagerBase => {
    if (ConferenceManager.getToken()) return new ConferenceManager(apolloClient, store);

    return new HeimdallManager(apolloClient, store, new HeimdallSession());
};
